import { baseURL } from './http.js';
import request from './request.js';

export default {
  // 寻样确认列表
  getConfirmOrderList: item => request(baseURL).post('oOrder/getOrderConfirmInfo', item),
  // 寻样确认
  batchAddDeliveryInfo: item => request(baseURL).post('oOrder/batchAddDeliveryInfo', item),
  // 样品寄出
  batchAddConfirmInfo: item => request(baseURL).post('oOrder/batchAddConfirmInfo', item),
  // 寻样申请
  getCheckOrderListAll: item => request(baseURL).post('oOrder/getOrderCheckInfo', item),
  batchCreate: item => request(baseURL).post('oOrder/batchCreate', item),
  updateOrder: item => request(baseURL).post('oOrder/update', item),
  // 寻样审核
  getOrderDetail: val => request(baseURL).get(`oOrder/get?id=${val}`),
  addCheckInfo: item => request(baseURL).post('oOrder/addCheckInfo', item),
  // 样品收货
  getOrderDeliveryInfo: item => request(baseURL).post('oOrder/getOrderDeliveryInfo', item),
  batchReceipt: item => request(baseURL).post('oOrder/batchReceipt', item),
  // 样品反馈
  getOrderCompleteInfo: item => request(baseURL).post('oOrder/getOrderCompleteInfo', item),
  batchGet: item => request(baseURL).post('oOrder/batchGet', item),
  addFeedback: item => request(baseURL).post('oOrder/addFeedback', item),
  // 我的寻样查询
  getMyOrderList: item => request(baseURL).post('oOrder/mylist', item),
  getList: item => request(baseURL).post('oOrder/list', item),
  // 批量寻样审核
  batchAddCheckInfo: item => request(baseURL).post('oOrder/batchAddCheckInfo', item),
  // 批量提交
  batchSubmit: item => request(baseURL).post('oOrder/batchSubmit', item),
  
  // 库外转办
  oOrderApprovalTransfer: item => request(baseURL).post('oOrder/approvalTransfer', item),
  // 库内审核转办
  orderApprovalTransfer: item => request(baseURL).post('order/approvalTransfer', item),
  oOrderLeadApproval: item => request(baseURL).post('oOrder/approval', item),
  oOrderLeadChange: item => request(baseURL).post('oOrder/change', item),
  oOrderLeadInfo: item => request(baseURL).post('oOrder/getOrderLeadInfo', item),
};